/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PolicyValueDetailsViewModel
 */
export interface PolicyValueDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    currentMarketValue: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    incurredCapitalGainsTax: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    unrealisedCapitalGainsTax: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    netValue: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    cashValueIfSurrendered: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyValueDetailsViewModel
     */
    outstandingLoanAmount: number;
}

/**
 * Check if a given object implements the PolicyValueDetailsViewModel interface.
 */
export function instanceOfPolicyValueDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "currentMarketValue" in value;
    isInstance = isInstance && "incurredCapitalGainsTax" in value;
    isInstance = isInstance && "unrealisedCapitalGainsTax" in value;
    isInstance = isInstance && "netValue" in value;
    isInstance = isInstance && "cashValueIfSurrendered" in value;
    isInstance = isInstance && "outstandingLoanAmount" in value;

    return isInstance;
}

export function PolicyValueDetailsViewModelFromJSON(json: any): PolicyValueDetailsViewModel {
    return PolicyValueDetailsViewModelFromJSONTyped(json, false);
}

export function PolicyValueDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicyValueDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentMarketValue': json['CurrentMarketValue'],
        'incurredCapitalGainsTax': json['IncurredCapitalGainsTax'],
        'unrealisedCapitalGainsTax': json['UnrealisedCapitalGainsTax'],
        'netValue': json['NetValue'],
        'cashValueIfSurrendered': json['CashValueIfSurrendered'],
        'outstandingLoanAmount': json['OutstandingLoanAmount'],
    };
}

export function PolicyValueDetailsViewModelToJSON(value?: PolicyValueDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CurrentMarketValue': value.currentMarketValue,
        'IncurredCapitalGainsTax': value.incurredCapitalGainsTax,
        'UnrealisedCapitalGainsTax': value.unrealisedCapitalGainsTax,
        'NetValue': value.netValue,
        'CashValueIfSurrendered': value.cashValueIfSurrendered,
        'OutstandingLoanAmount': value.outstandingLoanAmount,
    };
}

